// target blank script
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
    }
}

// ABZ Main Images Slider
$('#mainslideshow').owlCarousel({
    autoplay: true,
    nav: false,
    dots: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})

// Images Slider
$('#imagesslider').owlCarousel({
    nav: true,
    dots: false,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})

// Home Images Slider
$('#homeimagesslider').owlCarousel({
    nav: true,
    dots: false,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})


// Testimonial
$('#testimonial').owlCarousel({
    nav: true,
    margin: 30,
    dots: false,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
            items: 2
        }
    }
})

// Menstrual Disc Slider 
$('#menstrualdiscslider').owlCarousel({
    nav: false,
    dots: true,
    autoplay: 200,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})


// Image With Text Slider 
$('#imagetextslider').owlCarousel({
    nav: true,
    dots: true,
    loop: true,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: false,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})

// Size PopUp
$(document).ready(function () {

    $(".open").click(function () {
        $(".pop-outer").fadeIn("slow");
    });
    $(".close").click(function () {
        $(".pop-outer").fadeOut("slow");
    });
});

// Image With Text Slider 1
$('#imagetextslider-1').owlCarousel({
    nav: true,
    dots: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})

// Only Images Slider 
$('#onlyimageslider').owlCarousel({
    nav: false,
    dots: true,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})

// Only Images Slider 1
$('#onlyimageslider-1').owlCarousel({
    nav: false,
    dots: true,
    loop: true,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: false,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})

// Button Images Slider
$('#buttonimagesslider').owlCarousel({
    nav: true,
    dots: false,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})

// Single Image Slider 
$('.singleimageslider').owlCarousel({
    nav: false,
    dots: true,
    loop: true,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: false,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})